import { useSelector } from "react-redux";
import { useInactive } from "../../hooks/useInactive";
import { useAbacSessionPending } from "../../hooks/useAbacAccess";
import { authSelector } from "../Auth/AuthSlice";
import { Outlet, useLocation } from "react-router-dom";
import { hasRole, hasRoles, isManager, isSeller } from "../../lib/utility";
import RedirectToDashboard from "./RedirectToDashboard";
import RedirectToLogin from "./RedirectToLogin";
import SuspenseLoader from "./SuspenseLoader";
import { getInternalPathFromLocation } from "../../lib/routeTokens";
import { isAbacRouteAllowed } from "../User/Abac/abacRouteMap";


const ProtectedRoute = ({ role, navOption, customValidation, abacPath }) => {
  const { user, navOptions, abacPermissions } = useSelector(authSelector);
  const location = useLocation();
  const abacPending = useAbacSessionPending();

  useInactive(user, +(import.meta.env.VITE_REACT_APP_STALL_TIME || "0"));

  if (role === "public") {
    return (
      <SuspenseLoader>
        <Outlet />
      </SuspenseLoader>
    );
  }

  if (role === "guest") {
    if (!hasRole(user) || !globalThis.isAuthenticated) {
      return (
        <SuspenseLoader>
          <Outlet />
        </SuspenseLoader>
      );
    } else {
      return <RedirectToDashboard />;
    }
  }

  if (
    (!user?.roles && !user?.role) ||
    !globalThis.isAuthenticated
  ) {
    return <RedirectToLogin />;
  }

  if (abacPending) {
    return (
      <SuspenseLoader>
        <Outlet />
      </SuspenseLoader>
    );
  }

  const hasRoleAccess = role ? hasRoles(role, user) : true;

  let hasNavAccess = true;
  if (navOption && !isSeller(user) && !isManager(user)) {
    hasNavAccess = Boolean(navOptions?.[navOption]);
  }

  let hasCustomAccess = true;
  if (typeof customValidation === "function") {
    hasCustomAccess = customValidation(user, navOptions);
  } else if (customValidation !== undefined) {
    hasCustomAccess = Boolean(customValidation);
  }

  // Multi-access members only: hide routes when the ABAC permission is false.
  // Route map needs the logical path (URLs may be obfuscated as /du/{token}).
  const hasAbacAccess = isAbacRouteAllowed(
    getInternalPathFromLocation(location),
    abacPermissions,
    user,
    globalThis.profileData,
    abacPath
  );

  if (hasRoleAccess && hasNavAccess && hasCustomAccess && hasAbacAccess) {
    return (
      <SuspenseLoader>
        <Outlet />
      </SuspenseLoader>
    );
  } else {
    return <RedirectToDashboard />;
  }
};
export default ProtectedRoute;
